var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-layout',[_c('tiptap',_vm._b({on:{"input":_vm.updateHtml}},'tiptap',_vm.$props,false)),_c('button',{on:{"click":function($event){return _vm.$emit('close', _vm.html)}}},[_vm._v("Close dialog")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }